var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.747,
    height: 89.718,
    viewBox: "0 0 90.747 89.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_viviendas",
    transform: "translate(-305.5 -896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6451",
    "data-name": "Rectangle 6451",
    width: 89.718,
    height: 89.718,
    transform: "translate(306 896)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8217",
    "data-name": "Group 8217",
    transform: "translate(332.002 863.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19832",
    "data-name": "Path 19832",
    d: "M394.1,333a3.6,3.6,0,1,0,2.555,1.05A3.613,3.613,0,0,0,394.1,333Zm0,4.652a1.032,1.032,0,1,0,0-.038Z",
    transform: "translate(-349.758 -239.239)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19833",
    "data-name": "Path 19833",
    d: "M42.986,333a3.6,3.6,0,1,0,2.547,1.055A3.618,3.618,0,0,0,42.986,333Zm0,4.652a1.032,1.032,0,1,0,0-.038Z",
    transform: "translate(-54.889 -239.239)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19834",
    "data-name": "Path 19834",
    d: "M90.673,258.04H89.519a1.282,1.282,0,0,0,0,2.563h1.154a1.282,1.282,0,0,0,0-2.563Z",
    transform: "translate(-95.937 -176.288)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19835",
    "data-name": "Path 19835",
    d: "M46.619,52.9H41.492V49.4a1.282,1.282,0,0,0-1.282-1.282h-11.7A1.282,1.282,0,0,0,27.227,49.4v3.5H22.1A17.072,17.072,0,0,0,13.128,84.52H3.554V56.438a1.282,1.282,0,0,0-1.282-1.282H-9.712a5.127,5.127,0,0,0-4.383,2.461L-25.258,75.932A5.13,5.13,0,0,0-26,78.6V95.2a1.282,1.282,0,0,0,.376.906,1.282,1.282,0,0,0,.906.376h4.127v.859a8.754,8.754,0,0,0,4.467,7.3,8.754,8.754,0,0,0,8.56,0,8.756,8.756,0,0,0,4.468-7.3v-.859H35.635v.859a8.754,8.754,0,0,0,17.5,0v-.859h5.357A1.282,1.282,0,0,0,59.77,95.2V85.8a1.282,1.282,0,0,0-1.282-1.282H55.578A17.072,17.072,0,0,0,46.607,52.9ZM29.79,50.683h9.126V52.9H29.79ZM-15.223,64.4h11.01V76.625H-22.669Zm3.319,39.117a6.188,6.188,0,0,1-4.384-1.807,6.19,6.19,0,0,1-1.819-4.38,6.19,6.19,0,0,1,1.813-4.381,6.19,6.19,0,0,1,4.381-1.813,6.187,6.187,0,0,1,4.38,1.819,6.188,6.188,0,0,1,1.807,4.384,6.178,6.178,0,0,1-1.809,4.368,6.177,6.177,0,0,1-4.368,1.809Zm0-14.88a8.778,8.778,0,0,0-4.831,1.457,8.776,8.776,0,0,0-3.231,3.875h-3.473V79.188H-2.931a1.282,1.282,0,0,0,.906-.376,1.282,1.282,0,0,0,.376-.906V63.116a1.282,1.282,0,0,0-.376-.906,1.282,1.282,0,0,0-.906-.376h-10.74L-11.9,58.95a2.564,2.564,0,0,1,2.2-1.282H1V93.915H-3.829a8.754,8.754,0,0,0-3.244-3.853A8.756,8.756,0,0,0-11.9,88.634Zm56.241,14.88a6.177,6.177,0,1,1,4.377-1.8,6.193,6.193,0,0,1-4.377,1.8ZM57.154,87.083v6.832H52.4a8.753,8.753,0,0,0-16.111,0H3.554V87.083ZM46.644,84.52H22.074a14.534,14.534,0,1,1,0-29.056H46.619a14.534,14.534,0,1,1,0,29.056Z",
    transform: "translate(0 0)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19836",
    "data-name": "Path 19836",
    d: "M318.334,129.4c-.205.257-4.973,6.408-4.973,11.407a5.986,5.986,0,0,0,11.958,0c0-5.024-4.768-11.151-4.973-11.407a1.281,1.281,0,0,0-2.013,0Zm1.013,14.816a3.423,3.423,0,0,1-3.422-3.409c0-2.871,2.115-6.408,3.422-8.408,1.282,1.948,3.409,5.537,3.409,8.408a3.423,3.423,0,0,1-3.409,3.409Z",
    transform: "translate(-284.993 -67.849)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTruck);
export default __webpack_public_path__ + "static/media/ico_truck.ffa0d3f42a1b9d52794d3b4f6c4acf9a.svg";
export { ForwardRef as ReactComponent };